const checkStatus = (response) => {
  return new Promise((resolve, reject) => {
    if (response.status >= 200 && response.status < 400) {
      resolve(response);
    } else {
      response.text().then((msg) => {
        var error = new Error(`${response.statusText}: ${msg}`);
        error.response = response;
        reject(error);
      });
    }
  });
};

const ajax = (url, auth, method, payload) => {
  var headers = new Headers();
  var isAuthenticated = auth.user !== null && !auth.user.expired;

  if (isAuthenticated) {
    headers.append("Authorization", "Bearer " + auth.user.access_token);
  }

  headers.set("Content-Type", "application/json; charset=utf-8");

  var p = {
    method: method,
    headers: headers,
    body: JSON.stringify(payload),
  };

  return fetch(url, p).then(checkStatus);
};

export const get = (url, auth) => {
  console.log("GET " + url);
  return ajax(url, auth, "GET").then((response) => {
    if (response.status === 204 || response.status === 304) return null;

    return response.json();
  });
};

const del = (url, auth) => {
  console.log("DELETE " + url);
  return ajax(url, auth, "DELETE").then((response) => response.json());
};

const post = (url, auth, payload) => {
  console.log("POST " + url, payload);
  return ajax(url, auth, "POST", payload).then((response) => response.json());
};

const put = (url, auth, payload) => {
  console.log("PUT " + url, payload);
  return ajax(url, auth, "PUT", payload).then((response) => response.json());
};

export const httpMiddleware =
  (apiUri) =>
  ({ dispatch, getState }) =>
  (next) =>
  (action) => {
    if (action.url && action.method) {
      const auth = getState().oidc;
      const url = apiUri + action.url;
      const promise = (function () {
        switch (action.method) {
          case "GET":
            return get(url, auth);
          case "POST":
            return post(url, auth, action.payload);
          case "PUT":
            return put(url, auth, action.payload);
          case "DELETE":
            return del(url, auth);
          default:
            throw new Error("Unsupported method " + action.method);
        }
      })();

      if (action.then) {
        promise.then((result) => {
          dispatch(action.then(result));
        });
      }

      dispatch({
        type: action.type,
        promise,
        $isWrite: action.method !== "GET",
      });
    } else {
      next(action);
    }
  };

export const httpDevMiddleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    if (action.url && action.method) {
      // const title = `${action.method}: ${action.url}. \r\n`;
      // const data = action.payload ? JSON.stringify(action.payload) : '';

      const promise = new Promise((resolve, reject) =>
        setTimeout(() => {
          resolve({});
        }, 1000)
      );

      if (action.then) {
        promise.then(() => dispatch(action.then({})));
      }

      dispatch({
        type: action.type,
        promise,
        $isWrite: action.method !== "GET",
      });
    } else {
      next(action);
    }
  };
